<script setup lang="ts">
  defineProps<{
    icon: string
    name: string
  }>()
</script>

<template>
  <div class="n-dropdown-option-body__label flex items-center">
    <div class="flex items-center justify-center gap-2">
      <span class="min-w-11 text-sm leading-6 font-semibold">{{ name }}</span>
      <img
        :src="icon"
        alt=""
        aria-hidden="true"
        class="size-4 shrink-0 border border-(--color-border)"
      />
    </div>
  </div>
</template>
